import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class ProjectInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showMemoCreateModal = this.showMemoCreateModal.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal     : false,
      memo_id   : null,
      is_active : false,
    };
  }
  // -------------------------------------------------------
  
  showMemoCreateModal(memo_id, message) {
    this.setState({ modal: true, memo_id: memo_id });
    
    setTimeout( function(){
      this.message.value = message;
      this.check.bind(this)();
    }.bind(this), 10);
  }
  // -------------------------------------------------------
  
  closeMemoCreateModal() {
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  check() {
    this.setState({ is_active: ( this.message.value != '' ) });
  }
  // -------------------------------------------------------
  
  completeAction() {
    Utils.request.bind(this)('/api/project/workflow/set_memo', { project_id: this.props.data.project.id, update: { memo_id: this.state.memo_id, message: this.message.value } },
      function(res){
        this.props.data.event.updateData.bind(this)('projects_memo', res.body.projects_memo);
        this.closeMemoCreateModal.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  deleteAction() {
    let chk = confirm('メモを削除します。よろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/workflow/set_memo', { project_id: this.props.data.project.id, update: { memo_id: this.state.memo_id, delete: true } },
      function(res){
        this.props.data.event.updateData.bind(this)('projects_memo', res.body.projects_memo);
        this.closeMemoCreateModal.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    let detail = base.project.detail;
    
    let height = (this.state.memo_id != null) ? 450 : 425;
    
    return (
      <div className="project-memo-create-modal">
        <ContentsModal
          view      = {this.state.modal}
          width     = {400}
          height    = {height}
          close_ev  = {this.closeMemoCreateModal.bind(this)}
          html      = {
            <div className="modal-item">
              <h2>メモの作成</h2>
              <h4>作成した内容はワークフロー内に表示されます</h4>
              
              <textarea className="text" ref={(input) => { this.message = input }} onChange={this.check.bind(this)} placeholder={'メモの内容を入力'} />
              
              { (this.state.is_active == true)
                ? <div className="button on" onClick={this.completeAction.bind(this)}>登録</div>
                : <div className="button off">登録</div>
              }
              
              { (this.state.memo_id != null) &&
                <div className="delete-button" onClick={this.deleteAction.bind(this)}>メモを削除</div>
              }
            </div>
          }
        />
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInfluencer;